import { useLazyQuery, useQuery } from "@apollo/client";
import { CATEGORY } from "../category.queries";
import { CategoryQuery, CategoryQueryVariables } from "../../../__generated__/CategoryQuery";

export const useCategory = (id: number) => {
  return useQuery<CategoryQuery, CategoryQueryVariables>(CATEGORY, { variables: { id } });
};

export const useLazyCategory = () => {
  return useLazyQuery<CategoryQuery, CategoryQueryVariables>(CATEGORY);
};
